import { BrandIntegrationStatus, IntegrationType } from 'constants/integrations';

export const VALID_INTEGRATION_TYPES = [
  IntegrationType.Facebook,
  IntegrationType.Shopify,
  IntegrationType.Klaviyo,
] as const;

export type ValidIntegrationType = (typeof VALID_INTEGRATION_TYPES)[number];

export type IntegrationState = {
  type: ValidIntegrationType;
  name: string;
  icon: React.ReactNode | null;
  isConnected: boolean;
  status: BrandIntegrationStatus;
  onConnect: (type: ValidIntegrationType) => void;
};

export type Message = {
  id: string;

  // The content is in markdown format. Raw strings count as markdown.
  content: string;
  vizBase64?: string | null | undefined;
  timestamp: string;
  sender: 'user' | 'agent';
  responseOf?: Message;
  feedback?: {
    upvote: boolean;
    downvote: boolean;
  };
};

export type AIAgentViewProps = {
  loading: { [key in 'integrations' | 'api']: boolean };
  integrations: IntegrationState[];
  messages: Message[];
  onSendMessage: (message: string) => void;
  onFeedbackClick: (messageId: string, feedback: 'up' | 'down') => void;
};

/**
 * API response object from the agent endpoint
 */
export type AgentResponse = {
  messageContent: string;
  vizBase64: string | null;
};
